module.exports = __webpack_public_path__ + "static/media/36.feb96409.jpg";